import TopButton from "@/components/shared/TopButton";
import RootNavList from "./RootNavList";
import { cn } from "@/lib/utils";

export default function RootNav() {
  return (
    <>
      {/* Top Btn */}
      <TopButton />

      {/* Header */}
      <header
        className={cn("fixed  z-50 w-full    bg-zinc-700/1")}
        style={{
          backdropFilter: "blur(2px)",
        }}
      >
        <div
          className={cn(
            "text-white flex items-center layout-center justify-between py-2 px-0 grid-layout mx-auto"
          )}
        >
          {/* Header- Con */}
          <RootNavList />
        </div>
      </header>
    </>
  );
}
